import { useEffect, useState } from 'react';

// material-ui
import { Button, CardActions, CardContent, Divider, Grid, Modal, Typography, useTheme } from '@mui/material';

// project imports
import MainCard from 'components/cards/MainCard';

// assets
import useAPIError from 'hooks/useThrowAsyncError';
import { resolveDisplayErrorMessage } from 'utils/resolveDisplayErrorMessage';
import { FormattedMessage, useIntl } from 'react-intl';

// modal position
function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`
    };
}

// ==============================|| ERROR MODAL ||============================== //

export default function ErrorModal() {
    const theme = useTheme();
    const [modalStyle] = useState(getModalStyle);
    const { error, removeError } = useAPIError();
    const intl = useIntl();
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        if (error === null) {
            return;
        }
        const messages = intl.messages as Record<string, string>;
        const values =
            error.details && typeof error.details === 'object' && !Array.isArray(error.details)
                ? (error.details as Record<string, string>)
                : undefined;
        setErrorMessage(resolveDisplayErrorMessage(String(error.message || error.code || '1000'), messages, intl.formatMessage, values));
    }, [error, intl]);

    const handleClose = () => {
        removeError();
    };

    return (
        <Grid container justifyContent="flex-start">
            <Modal open={!!error} onClose={handleClose} aria-modal="true" role="dialog">
                <div tabIndex={-1}>
                    <MainCard
                        style={modalStyle}
                        sx={{
                            position: 'absolute',
                            width: { xs: 280, lg: 450 },
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            '& .MuiCardHeader-root': {
                                backgroundColor: theme.palette.error.light
                            }
                        }}
                        content={false}
                    >
                        <CardContent>
                            <Typography variant="body1">{errorMessage}</Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <Button
                                variant="contained"
                                type="button"
                                color="error"
                                onClick={handleClose}
                                sx={{
                                    backgroundColor: theme.palette.error.main
                                }}
                            >
                                <FormattedMessage id="ACEPTAR" />
                            </Button>
                        </CardActions>
                    </MainCard>
                </div>
            </Modal>
        </Grid>
    );
}
